function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4Z",
  fill: "#EAEAEB"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.8125 4.5H13.5625C14.5 4.5 15.25 5.25 15.25 6.1875V12.1875C15.25 12.7734 14.9453 13.2891 14.5 13.5938V15.375H14.6875C14.9922 15.375 15.25 15.6328 15.25 15.9375C15.25 16.2422 14.9922 16.5 14.6875 16.5H6.625C5.59375 16.5 4.75 15.6562 4.75 14.625V6.5625C4.75 5.41406 5.66406 4.5 6.8125 4.5ZM13.375 13.875H6.625C6.20312 13.875 5.875 14.2031 5.875 14.625C5.875 15.0469 6.20312 15.375 6.625 15.375H13.375V13.875ZM6.625 12.75H13.5625C13.8672 12.75 14.125 12.4922 14.125 12.1875V6.1875C14.125 5.88281 13.8672 5.625 13.5625 5.625H6.8125C6.29688 5.625 5.875 6.04688 5.875 6.5625V12.9141C6.10938 12.7969 6.36719 12.75 6.625 12.75ZM7.75 8.0625C7.75 7.75781 8.00781 7.5 8.3125 7.5H12.4375C12.7422 7.5 13 7.75781 13 8.0625C13 8.36719 12.7422 8.625 12.4375 8.625H8.3125C8.00781 8.625 7.75 8.36719 7.75 8.0625ZM8.3125 9.75H12.4375C12.7422 9.75 13 10.0078 13 10.3125C13 10.6172 12.7422 10.875 12.4375 10.875H8.3125C8.00781 10.875 7.75 10.6172 7.75 10.3125C7.75 10.0078 8.00781 9.75 8.3125 9.75Z",
  fill: "#636766"
});

function SvgGrayCourse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayCourse);
export default __webpack_public_path__ + "static/media/gray-course.54a3a106.svg";
export { ForwardRef as ReactComponent };